import { render, staticRenderFns } from "./ImportCSV.vue?vue&type=template&id=3124b762&"
import script from "./ImportCSV.vue?vue&type=script&lang=ts&"
export * from "./ImportCSV.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports